export const FAQ_LIST_REQUEST = "FAQ_LIST_REQUEST";
export const FAQ_LIST_SUCCESS = "FAQ_LIST_SUCCESS";
export const FAQ_LIST_FAIL = "FAQ_LIST_FAIL";
export const FAQ_CLEAR = "FAQ_CLEAR";

export const FAQ_DELETE_REQUEST = "FAQ_DELETE_REQUEST";
export const FAQ_DELETE_SUCCESS = "FAQ_DELETE_SUCCESS";
export const FAQ_DELETE_FAIL = "FAQ_DELETE_FAIL";

export const FAQ_ADD_REQUEST = "FAQ_ADD_REQUEST";
export const FAQ_ADD_SUCCESS = "FAQ_ADD_SUCCESS";
export const FAQ_ADD_FAIL = "FAQ_ADD_FAIL";

export const FAQ_EDIT_REQUEST = "FAQ_EDIT_REQUEST";
export const FAQ_EDIT_SUCCESS = "FAQ_EDIT_SUCCESS";
export const FAQ_EDIT_FAIL = "FAQ_EDIT_FAIL";

export const FAQ_UPDATE_REQUEST = "FAQ_UPDATE_REQUEST";
export const FAQ_UPDATE_SUCCESS = "FAQ_UPDATE_SUCCESS";
export const FAQ_UPDATE_FAIL = "FAQ_UPDATE_FAIL";
export const FAQ_UPDATE_RESET = "FAQ_UPDATE_RESET";
